import React, { Component } from "react";
import "./greetings.scss";

class Greetings extends Component {
  render() {
    return <div className="home">Thank you for using Prodoo</div>;
  }
}
export default Greetings;
